module.exports = __webpack_public_path__ + "media/images/web/home/index/employment-cef54fb6146ec078a086757c037210a2.jpg";